import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import HomeHeader from '@/components/header/home-header.vue';
import BlockContainer from './block-container.vue';
import XichengBanner from '@/views/home/part/banner/index.vue';
import CommonTitleTemplate from './common-title-template.vue';
import CardListTemplate from './card-list-template/index.vue';
import NewsNoticeCard from '../module/news-notice-card.vue';
import CommonFooter from './common-footer.vue';
import CommonHeaderMenu from './common-header-menu.vue';
import ProjectList from './project-list.vue';
import HomeBanner from './home-banner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'render-fragment',
  props: {
    template: {
        type: [Object, String, Number, Boolean],
        default: () => {
            return {};
        },
    },
},
  setup(__props) {

const props = __props;

const componentMap = {
    HomeHeader,
    BlockContainer,
    XichengBanner,
    CommonTitleTemplate,
    NewsNoticeCard,
    CardListTemplate,
    CommonFooter,
    CommonHeaderMenu,
    ProjectList,
    HomeBanner,
};



return (_ctx: any,_cache: any) => {
  const _component_RenderFragment = _resolveComponent("RenderFragment", true)!

  return (typeof __props.template === 'object')
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(componentMap[__props.template.name] || __props.template.name), _normalizeProps(_mergeProps({ key: 0 }, __props.template.props)), {
        default: _withCtx(() => [
          (__props.template.children?.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.template.children, (item) => {
                return (_openBlock(), _createBlock(_component_RenderFragment, {
                  key: item.modelKey,
                  template: item
                }, null, 8, ["template"]))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createTextVNode(_toDisplayString(__props.template), 1)
      ], 64))
}
}

})